import JobTypeJSON from 'app/assets/jsons/PlacementTypes.json';

export function GetPlacementTypes() {
  const data = JobTypeJSON.placementTypes;
  return data;
}
